import { useRoute } from 'wouter';
import { Suspense } from 'react';
import { Helmet } from 'react-helmet';
import { Container } from '@/components/ui/container';
import { Skeleton } from '@/components/ui/skeleton';
import { InstallationInlineForm } from '@/components/installations/installation-inline-form';

export default function EditInstallationPage() {
  const [match, params] = useRoute<{ id: string }>('/installations/:id/edit');

  if (!match) {
    return null;
  }

  const installationId = parseInt(params.id);

  return (
    <>
      <Helmet>
        <title>Edit Installation | DomElec Solar</title>
      </Helmet>
      <Container className="py-8 max-w-7xl mx-auto">
        <Suspense fallback={<Skeleton className="h-[600px] w-full" />}>
          <InstallationInlineForm installationId={installationId} />
        </Suspense>
      </Container>
    </>
  );
}
